interface AnswerCardProps {
  question?: string;
  paragraphs: string[];
}

export default function AnswerCard({ question, paragraphs }: AnswerCardProps) {
  return (
    <div className="service-answer-card">
      {question ? <h3>{question}</h3> : null}
      {paragraphs.map((p, i) => (
        <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
      ))}
    </div>
  );
}
